<template>
  <div
    class="new"
    :class="{ 'has-subject': subject.id }"
  >
    <DayPicker
      class="new__days"
      v-model="date"
    />

    <router-view
      @saved="activitySaved"
      :date="date"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import DayPicker from '@/components/DayPicker'

export default {
  name: 'NewIndex',

  components: {
    DayPicker
  },

  data () {
    return {
      date: '',
      subject: {},
      activity: {}
    }
  },

  methods: {
    ...mapActions(['activities/addActivity']),

    activitySaved (activity) {
      this['activities/addActivity'](activity)

      this.$router.push({ name: 'new-subject' })
    }
  },

  created () {
    this.date = this.$options.filters.shortISO()
  }
}
</script>
